import React from "react";

const NotificationsModal = ({ notifications, onNotificationClick }) => {
  const hasItems = Array.isArray(notifications) && notifications.length > 0;
  const templateNotifications = [
    { title: "Welcome to!", desc: "Thanks for joining us 🐾", time: "Just now" },
    { title: "New feature", desc: "Check out gifts and coupons in the header.", time: "Today, 10:00" },
    { title: "Stay tuned", desc: "More updates are coming soon!", time: "Yesterday" },
  ];
  const list = hasItems ? notifications : templateNotifications;
  
  const handleClick = (note) => {
    if (note.id && onNotificationClick) {
      onNotificationClick(note.id);
    }
  };
  
  return (
    <div className="notification-modal">
      <div className="notification-header">
        <span>Notifications</span>
      </div>
      <div className="notification-list">
        {list.map((note, index) => (
          <div 
            className="notification-cardTwo" 
            key={note.id || index}
            onClick={() => handleClick(note)}
            style={{ cursor: note.id ? 'pointer' : 'default' }}
          >
            <div className="notification-title">{note.title}</div>
            <div className="notification-desc">{note.desc}</div>
            <div className="notification-time">{note.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationsModal;
